module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedLight.d363d57.woff";